module.exports = __webpack_public_path__ + "img/placeholder-ticket.5c16e13b.svg";